import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { Facet } from 'engine/facets/Facet';
import { SpriteGroupFacet } from 'engine/facets/SpriteGroupFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { Activatable } from 'game/behaviors/Activatable';
import { FILTER_OUTLINE_ID } from 'game/defs/FilterOutline';
import { AlertSprite } from 'game/sprites/AlertSprite';
import { TooltipSprite } from 'game/sprites/TooltipSprite';
import { inGameUIClasses } from 'game/styles/inGameUI';
import { colors } from 'game/styles/theme';
import { createElement } from 'react';
import { FranklinShadowSprite, FranklinSprite } from './TentIntSprite';

let hasMessage = true;

interface FranklinProps {
  onTalk: () => void,
}

class FranklinBehavior extends Facet<FranklinProps> {
  update(delta: number, engine: Engine) {
    if (engine.input.keyDown.KeyE) {
      this.props.onTalk();
    }
  }
}

export class FranklinEntity extends Entity<FranklinProps> {
  createFacets(props: FranklinProps) {
    const sprite = create(SpriteGroupFacet, {
      children: [create(StaticSpriteFacet, { frame: FranklinSprite, offset: [-46, -85] })],
    });
    const alertSprites = [
      create(StaticSpriteFacet, {
        frame: TooltipSprite({
          opacity: 1,
          fill: colors.white,
          stroke: colors.black,
          strokeWidth: 2,
        }),
        offset: [0, -160],
        opacity: Number(hasMessage),
      }),
      create(StaticSpriteFacet, {
        frame: AlertSprite({ className: inGameUIClasses.shake }),
        offset: [-13, -200],
        opacity: Number(hasMessage),
      }),
    ];
    const onTalk = () => {
      hasMessage = false;
      props.onTalk();

      // For some reason, removing these sprites causes Chrome to chug
      alertSprites.forEach(s => { s.props.opacity = 0; });
    };
    const behavior = create(FranklinBehavior, { onTalk });
    let text: StaticSpriteFacet | null = null;

    return [
      create(StaticSpriteFacet, { frame: FranklinShadowSprite, offset: [-25, -8] }),
      sprite,
      ...alertSprites,
      create(ColliderFacet, { type: ColliderType.Box, size: [120, 100], offset: [-60, 0] }),
      create(Activatable, {
        activate: (active, engine) => {
          sprite.props.filter = active ? `url(#${FILTER_OUTLINE_ID})` : undefined;

          if (active) {
            text = create(StaticSpriteFacet, {
              frame: createElement('text', {
                className: inGameUIClasses.activatedText,
                y: -110,
              }, '[e] Talk'),
            });
            this.addFacet(text, engine);
            this.addFacet(behavior, engine);
          } else if (text) {
            this.removeFacet(text);
            this.removeFacet(behavior);
          }
        },
      }),
    ];
  }
}
